import styled from 'styled-components'

export default styled.h1`
  font-size: 2em;
  font-weight: bold;
`